// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2a2a9713","239":"e39fb35b","455":"55372804","578":"580c2890","977":"8591a78c"}[chunkId] + ".chunk.js";
};